<template lang="pug">
option(
    :value="option.value"
    :selected="option.selected"
    :disabled="option.value === null") {{option.text}}
</template>

<script>
export default {
    props: ['option'],
}
</script>